const title = "Chart created using amCharts library";

export const removeAmChartLogo = (chartDiv: HTMLElement) => {
    // find all <title>
    const nodeList = chartDiv.querySelectorAll("title");
  
    nodeList.forEach(node => {
      if (node.textContent === title) {
        node.parentElement.remove();
      }
    });
  };